<script>
  import { fade, fly } from "svelte/transition";
  import { session } from "./js/store.js";
  import AXHR from "./js/axhr.js";
  import format from "number-format.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  let resultpoints;
  function loadpointsData(endpoint, token) {
    var data = {
      points: 700,
    };
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        resultpoints = response.data.points;
      })
      .catch(function (error) {
        resultpoints = 0;
      });
  }
  const startLoadPointsData = loadpointsData(
    sessions.api + "/points/me",
    sessions.token
  );
</script>

<div
  class="relative w-full overflow-hidden bg-white rounded-lg shadow-2xl bg-opacity-80 lg:rounded-lg"
>
  <div
    class="pt-0 pb-0 text-center lg:pt-10 md:pt-0 lg:text-center lg:pb-5 md:pb-24"
  >
    <div
      transition:fly={{ y: 200, duration: 500, delay: 500 }}
      class="relative w-full py-2 overflow-hidden bg-white bg-opacity-100 rounded-b-full shadow-xl rounded-lt-lg lg:rounded-lg lg:bg-transparent lg:shadow-none lg:bg-opacity-75"
    >
      <h1
        transition:fade={{ delay: 100, duration: 500 }}
        class="pt-0 mb-0 font-bold text-gray-800 uppercase lg:text-2xl md:text-2xl text-1xl lg:pt-0"
      >
        {sessions.user.firstName + " " + sessions.user.lastName}
      </h1>
      <h4
        transition:fade={{ delay: 150, duration: 500 }}
        class="relative clear-both px-3 py-1 mb-0 text-sm text-gray-700 normal-case rounded-full lg:text-xl "
      >
        {sessions.user.email}
      </h4>
    </div>
    <div
      transition:fly={{ y: 200, duration: 500, delay: 500 }}
      class="w-full my-5"
    >
      <h4
        transition:fade={{ delay: 200, duration: 500 }}
        class="relative clear-both px-3 py-1 mt-2 mb-0 text-2xl font-bold text-red-600 uppercase rounded-full"
      >
        {#if resultpoints}
          {format("#.##0,", resultpoints)}
        {:else}
          -
        {/if}
      </h4>
      <span
        transition:fade={{ delay: 250, duration: 500 }}
        class="clear-both px-3 py-1 text-xs text-red-100 bg-red-700 rounded-full shadow-lg"
      >
        Points
      </span>
    </div>
  </div>
</div>
